import axiosInstance from "./api_helper";

const entrepotservice = {
    list: async (params) => {
        return axiosInstance.get('/api/entrepots', params ? { params } : undefined);
    },

    addEntrepot: async (payload) => {
        return await axiosInstance.post('/api/entrepots', payload); 
    },

    update: async (id, data) => {
        return axiosInstance.put(`/api/entrepots/${id}`, JSON.stringify(data));
    },

    getLatestReceptions: async (id) => {
        return axiosInstance.get(`/api/entrepots/latest-receptions/${id}`);
    },

    getLatestDeliveries: async (id) => {
        return axiosInstance.get(`/api/entrepots/latest-deliveries/${id}`);
    },
};

export default entrepotservice;
